class Canal {
  stocks: number = 0;

  getFlowWithDotacion(dotacion: number): number {
    return this.stocks * dotacion;
  }
}

export { Canal };
